export default "__VITE_ASSET__BKvP2VI___"